// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.q3po-bare-page[data-v-6b10f959] {
  --q3po-font-floor: 16px;
}
.q3po-bare-page[data-v-6b10f959] button,
.q3po-bare-page[data-v-6b10f959] input,
.q3po-bare-page[data-v-6b10f959] select,
.q3po-bare-page[data-v-6b10f959] textarea,
.q3po-bare-page[data-v-6b10f959] code,
.q3po-bare-page[data-v-6b10f959] pre,
.q3po-bare-page[data-v-6b10f959] kbd,
.q3po-bare-page[data-v-6b10f959] samp {
  font-size: max(1em, var(--q3po-font-floor));
}
.dp-crumbs[data-v-6b10f959] {
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
  font-family: "Starjedi", "TradeGothic", sans-serif;
  font-weight: bold;
  font-size: 12px;
  line-height: 1;
  color: #c5c5cc;
}
.dp-crumb-sep[data-v-6b10f959] {
  color: #7a7a85;
}
[data-v-6b10f959] .dp-crumb-link {
  color: yellow;
  text-decoration: none;
}
[data-v-6b10f959] .dp-crumb-link:hover,[data-v-6b10f959] .dp-crumb-link:focus-visible {
  text-decoration: underline;
  outline: none;
}
.dp-crumb-current[data-v-6b10f959] {
  color: #f5f5f5;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/pages/Q3poAppPage.vue","webpack://./Q3poAppPage.vue"],"names":[],"mappings":"AAEA;EACE,uBAAA;ACDF;ADIA;;;;;;;;EAQE,2CAAA;ACDF;ADIA;EACE,oBAAA;EACA,qBAAA;EACA,QAAA;EACA,kDAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;ACDF;ADIA;EACE,cAAA;ACDF;ADIA;EACE,aAAA;EACA,qBAAA;ACDF;ADIA;EAEE,0BAAA;EACA,aAAA;ACDF;ADIA;EACE,cAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.q3po-bare-page {\n  --q3po-font-floor: 16px;\n}\n\n.q3po-bare-page :deep(button),\n.q3po-bare-page :deep(input),\n.q3po-bare-page :deep(select),\n.q3po-bare-page :deep(textarea),\n.q3po-bare-page :deep(code),\n.q3po-bare-page :deep(pre),\n.q3po-bare-page :deep(kbd),\n.q3po-bare-page :deep(samp) {\n  font-size: max(1em, var(--q3po-font-floor));\n}\n\n.dp-crumbs {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 8px;\n  font-family: 'Starjedi', 'TradeGothic', sans-serif;\n  font-weight: bold;\n  font-size: 12px;\n  line-height: 1;\n  color: #c5c5cc;\n}\n\n.dp-crumb-sep {\n  color: #7a7a85;\n}\n\n:deep(.dp-crumb-link) {\n  color: yellow;\n  text-decoration: none;\n}\n\n:deep(.dp-crumb-link:hover),\n:deep(.dp-crumb-link:focus-visible) {\n  text-decoration: underline;\n  outline: none;\n}\n\n.dp-crumb-current {\n  color: #f5f5f5;\n}\n",".q3po-bare-page {\n  --q3po-font-floor: 16px;\n}\n\n.q3po-bare-page :deep(button),\n.q3po-bare-page :deep(input),\n.q3po-bare-page :deep(select),\n.q3po-bare-page :deep(textarea),\n.q3po-bare-page :deep(code),\n.q3po-bare-page :deep(pre),\n.q3po-bare-page :deep(kbd),\n.q3po-bare-page :deep(samp) {\n  font-size: max(1em, var(--q3po-font-floor));\n}\n\n.dp-crumbs {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 8px;\n  font-family: \"Starjedi\", \"TradeGothic\", sans-serif;\n  font-weight: bold;\n  font-size: 12px;\n  line-height: 1;\n  color: #c5c5cc;\n}\n\n.dp-crumb-sep {\n  color: #7a7a85;\n}\n\n:deep(.dp-crumb-link) {\n  color: yellow;\n  text-decoration: none;\n}\n\n:deep(.dp-crumb-link:hover),\n:deep(.dp-crumb-link:focus-visible) {\n  text-decoration: underline;\n  outline: none;\n}\n\n.dp-crumb-current {\n  color: #f5f5f5;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
